export default [
  {
    path: "/quiz/quiz-list",
    name: "quiz-list",
    component: () => import("@/views/pages/survey-quiz/quiz-list/QuizList.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        active: true,
      },
    ],
  },
  {
    path: "/quiz/create",
    name: "quiz-create",
    component: () => import("@/views/pages/survey-quiz/quiz-info/QuizInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        to: "/quiz/quiz-list",
      },
      {
        text: "Custom For Brand",
        active: true,
      },
    ],
  },
  {
    path: "/quiz/info/:ref",
    name: "quiz-info",
    component: () => import("@/views/pages/survey-quiz/quiz-info/QuizInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz List",
        to: "/quiz/quiz-list",
      },
      {
        text: "Edit Quiz",
        active: true,
      },
    ],
  },
  {
    path: "/quiz/dashborad/:ref",
    name: "quiz-dashborad",
    component: () =>
      import("@/views/pages/survey-quiz/quiz-list/QuizDashborad.vue"),
    meta: {},
    props: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Quiz Dashboard",
        active: true,
      },
    ],
  },

  //survey
  {
    path: "/survey/survey-list",
    name: "survey-list",
    component: () =>
      import("@/views/pages/survey-quiz/survey-list/SurveyList.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        active: true,
      },
    ],
  },
  {
    path: "/survey/create",
    name: "survey-create",
    component: () =>
      import("@/views/pages/survey-quiz/survey-info/SurveyInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        to: "/survey/survey-list",
      },
    ],
  },
  {
    path: "/survey/info/:ref",
    name: "survey-info",
    component: () =>
      import("@/views/pages/survey-quiz/survey-info/SurveyInfo.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey List",
        to: "/survey/survey-list",
      },
      {
        text: "Edit Survey",
        active: true,
      },
    ],
  },
  {
    path: "/survey/dashborad/:ref",
    name: "survey-dashborad",
    component: () =>
      import("@/views/pages/survey-quiz/survey-list/SurveyDashboard.vue"),
    meta: {},
    breadcrumb: [
      {
        text: "Survey and Quiz",
      },
      {
        text: "Survey Dashboard",
        active: true,
      },
    ],
  },
];
